<template>
  <v-dialog :value="value" @click:outside="toggleDialog" max-width="307">
    <v-card class="calendar_dialog" :style="{ borderTop: `2px solid ${borderColor.color}` }">
      <v-icon class="calendar_dialog_icon-close" size="medium" color="icon" @click="toggleDialog"> mdi-close </v-icon>
      <div class="calendar_dialog_box calendar_dialog_box__margin">
        <v-skeleton-loader :loading="loading" type="text">
          <span class="calendar_dialog_email">{{ patient.email || "" }}</span>
        </v-skeleton-loader>
      </div>
      <div class="calendar_dialog_box calendar_dialog_box__margin">
        <span class="calendar_dialog_date">{{ $t("visits.waiting.patient") }}</span>
        <span class="calendar_dialog_patient-name">{{ schedule.title }}</span>
        <span class="calendar_dialog_email">{{ patient.email }}</span>
      </div>
      <div class="calendar_dialog_box calendar_dialog_box__margin">
        <span class="calendar_dialog_date">{{ scheduleDateString }}</span>
        <span class="calendar_dialog_time">{{ scheduleTimeIntervalString }}</span>
      </div>
      <div class="calendar_dialog_box calendar_dialog_reason">
        <span class="calendar_dialog_reason_title">{{ $t("visits.chiefComplaint") }}</span>
        <span class="calendar_dialog_reason_text">{{ schedule.raw.chiefComplaint }}</span>
      </div>
      <div class="calendar_dialog_box calendar_dialog_reason">
        <span class="calendar_dialog_reason_title">{{ $t("visits.visitReasonNote") }}</span>
        <span class="calendar_dialog_reason_text">{{ complaintDescription }}</span>
      </div>
      <div class="calendar_dialog_actions">
        <OutlinedButton
          class="calendar_dialog_actions__margin outlined-btn__red"
          :text="$t('practitioner.appointments.cancelVisit')"
          @onClick="onCancel"
        />
        <OutlinedButton
          :text="$t('practitioner.appointments.viewDetails')"
          color="primary"
          class="outlined-btn__blue"
          @onClick="onView"
        />
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { DateTime } from "luxon";
import { mapActions, mapGetters } from "vuex";

import { CheckoutApi } from "@/api/checkout";
import OutlinedButton from "@/components/uikit/OutlinedButton";
import { snackBarEventBus, snackBarEventName } from "@/eventBuses/snackBar.eventBus";
import { getColorByName } from "@/utils/pallete";
export default {
  name: "ScheduleDialog",
  props: {
    value: Boolean,
    schedule: { required: true, type: Object },
  },
  components: {
    OutlinedButton,
  },
  data: () => ({
    patientProfile: null,
    loading: false,
    checkout: {},
  }),
  watch: {
    patientProfile: async function (newSchedule) {
      try {
        this.loading = true;
        await this.getPatientProfile(newSchedule.raw.patientId);
      } catch (err) {
        snackBarEventBus.$emit(snackBarEventName, { message: err.message || err, type: "error" });
      }
      this.loading = false;
    },
  },
  methods: {
    ...mapActions(["getPatientProfile"]),
    toggleDialog() {
      this.$emit("onToggleDialog");
    },
    onCancel() {
      this.$emit("onCancel");
    },
    onView() {
      this.$emit("onView");
    },
  },
  computed: {
    ...mapGetters(["patient"]),
    scheduleDateString() {
      return DateTime.fromJSDate(this.schedule.start.toDate()).toFormat("d/MM/yyyy, EEEE");
    },
    scheduleTimeIntervalString() {
      return this.schedule.raw.timeInterval;
    },
    borderColor() {
      return getColorByName(this.schedule.color);
    },
    complaintDescription() {
      return this.checkout?.information?.complaintDescription;
    },
  },
  async mounted() {
    this.patientProfile = this.schedule;
    this.checkout = await CheckoutApi.getByAppointment(this.schedule.raw.appointmentId);
  },
};
</script>
